import moment from 'moment-timezone'

export const APP_TIMEZONE = 'Asia/Kolkata'

export const getAppTimezone = () => APP_TIMEZONE

const isMomentValue = (value) => moment.isMoment(value)
const hasExplicitTimezone = (value) => /(?:Z|[+-]\d{2}:?\d{2})$/i.test(value)

const parseInstant = (value) => {
  if (value === undefined || value === null || value === '') return null
  if (isMomentValue(value)) return value.clone()
  if (value instanceof Date) {
    const parsed = moment(value)
    return parsed.isValid() ? parsed : null
  }
  if (typeof value === 'number') {
    const parsed = moment.utc(value)
    return parsed.isValid() ? parsed : null
  }
  if (typeof value !== 'string' || !hasExplicitTimezone(value)) return null

  const parsed = moment.parseZone(value, moment.ISO_8601, true)
  return parsed.isValid() ? parsed : null
}

const parseBusinessValue = (value, format) => {
  if (value === undefined || value === null || value === '') return null
  if (isMomentValue(value) || value instanceof Date) {
    const parsed = moment(value).tz(APP_TIMEZONE)
    return parsed.isValid() ? parsed : null
  }

  const parsed = format
    ? moment.tz(value, format, true, APP_TIMEZONE)
    : moment.tz(
        value,
        [moment.ISO_8601, 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'HH:mm:ss', 'HH:mm'],
        true,
        APP_TIMEZONE,
      )
  return parsed.isValid() ? parsed : null
}

export const formatInstant = (value, format = 'DD/MM/YYYY HH:mm') => {
  const parsed = parseInstant(value)
  return parsed ? parsed.tz(APP_TIMEZONE).format(format) : ''
}

export const formatBusinessDate = (value, format = 'YYYY-MM-DD') => {
  const source = String(value ?? '')
  let parsed
  if (isMomentValue(value)) {
    parsed = moment.tz(value.format('YYYY-MM-DD'), 'YYYY-MM-DD', true, APP_TIMEZONE)
  } else if (/^\d{4}-\d{2}-\d{2}$/.test(source)) {
    parsed = parseBusinessValue(source, 'YYYY-MM-DD')
  } else {
    parsed = parseInstant(value)
  }
  return parsed ? parsed.tz(APP_TIMEZONE).format(format) : ''
}

export const formatBusinessDateTime = (value, format = 'DD/MM/YYYY HH:mm') => {
  const parsed = parseBusinessValue(value)
  return parsed ? parsed.format(format) : ''
}

export const parseBusinessDateTime = (value, format, strict = true) => {
  if (value === undefined || value === null || value === '') return null
  const parsed = format
    ? moment.tz(value, format, strict, APP_TIMEZONE)
    : moment.tz(value, APP_TIMEZONE)
  return parsed.isValid() ? parsed : null
}

export const toUtcIso = (value) => {
  const parsed = parseInstant(value)
  return parsed ? parsed.utc().toISOString() : ''
}
